import BaseComponent from '../../components/base-component/base-component'
import { Nullable } from '../../types/common'
import { getTemplateFirstChildContent } from '../../utils/dom'

class ProductBlock extends BaseComponent {
  blockSelector: string
  containerSelector: string
  activeTemplate: Nullable<HTMLElement>
  activeTemplateContainer: Nullable<HTMLElement>

  constructor() {
    super()

    this.blockSelector = `[data-product-block-item]`
    this.containerSelector = `[data-product-block-container]`

    this.activeTemplate = this.querySelector(this.blockSelector)
    this.activeTemplateContainer = this.querySelector(this.containerSelector)
  }

  updateByVariantId(variantId: number): void {
    const selectedTemplate = this.querySelector(
      `[data-product-block-template="${variantId}"]`,
    )

    if (this.activeTemplate && this.activeTemplateContainer) {
      const newTemplate = getTemplateFirstChildContent(selectedTemplate)

      if (newTemplate) {
        this.activeTemplate.remove()
        this.activeTemplate = newTemplate
        this.activeTemplateContainer.appendChild(newTemplate)
      }
    }
  }
}

export default ProductBlock
